<template>
  <div id="addSchedule">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol xs="12" sm="6" md="6" xl="6">
                  <BaseSelect
                    :options="slideShowInput.options"
                    :data="slideShowInput.data"
                    ref="slideShowInput"
                  >
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6">
                  <div class="form-group">
                    <label style="display: inline-flex;">Thiết bị
                      <span class="required">*</span>
                      <CInputCheckbox custom :checked="isSelectedAllDevices" class="ml-2"
                                      @update:checked="changeSelectedAllDevice($event)"
                                      addInputClasses="override-custom"></CInputCheckbox>
                      Chọn tất cả
                    </label>

                    <multiselect
                      id="deviceSelect"
                      v-model="deviceInput.data.model"
                      placeholder="Chọn thiết bị"
                      label="text"
                      track-by="value"
                      :options="deviceInput.options"
                      selectLabel="Chọn"
                      deselectLabel="Bỏ chọn"
                      selectedLabel="Đã chọn"
                      :close-on-select="false"
                      :class="!(deviceInput.data.validator && deviceInput.data.validator.isValid == true) ? 'input-error' : ''"
                      :multiple="true">
                      <span slot="noResult">Không có dữ liệu tương ứng!</span>
                      <span slot="noOptions">Danh sách rỗng!</span>
                    </multiselect>

                    <div class="valid-error"
                         v-show="!(deviceInput.data.validator ? deviceInput.data.validator.isValid : true)">
                      {{
                        deviceInput.data.validator
                          ? deviceInput.data.validator.errorMessage
                          : ""
                      }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6">
                  <BaseSelect
                    :options="modeSelect.options"
                    :data="modeSelect.data"
                    ref="modeSelect"
                  >
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model != 2">
                  <div class="form-group">
                    <label for="dateRanger">Ngày bắt đầu - Ngày kết thúc
                      <span class="required">*</span></label>
                    <DatePicker
                      id="dateRanger"
                      v-model="dateRange"
                      is-range
                      class="datepicker"
                      :input-props="{ readonly: true }"
                      :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }"
                      :min-date="new Date()"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <input
                          :value="inputValue.start + ' - ' + inputValue.end"
                          v-on="inputEvents.start"
                          class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300 " readonly
                        />
                      </template>
                    </DatePicker>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 1">
                  <BaseSelect
                    :options="modeSchedule.options"
                    :data="modeSchedule.data"
                    ref="modeSchedule">
                  </BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 1 || modeSelect.data.model == 0">
                  <div class="form-group mb-0"
                       :class="!(validatorRangeTimes ? validatorRangeTimes.isValid : true) ? 'input-error' : ''">
                    <label>Thời điểm phát <span class="required">*</span></label>
                    <CCard class="mb-1">
                      <CCardBody style="padding-top: 5px !important">
                        <CRow>
                          <CCol sx="12" sm="12" md="6" lg="6" xl="3" v-for="(each, index) in timeRange"
                                :key="each.start.getTime()">
                            <DatePicker
                              mode="time"
                              :masks="{ input: 'HH:MM', data: 'HH:MM' }"
                              :value="each"
                              is-range
                              is24hr
                              @input="changeTimeRange($event, index)"
                              ref="timeRange">
                              <template v-slot="{ inputValue, inputEvents , togglePopover, hidePopover}">
                                <CInput class="btn-time-ranger"
                                        :value="inputValue.start + ' - ' + inputValue.end"
                                        v-on="inputEvents.start"
                                        readonly
                                />
                                <svg
                                  v-c-tooltip.hover="'Xóa'"
                                  class="w-1 h-1 btn-remove-time"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  @click="removeTimeRange(index)"
                                >
                                  <path d="M6 18L18 6M6 6l12 12"></path>
                                </svg>
                              </template>
                            </DatePicker>
                          </CCol>
                        </CRow>
                        <CRow>
                          <CCol>
                            <CButton color="primary" class="mt-3" @click="addTimeRange()">
                              <i class="fa fa-plus"></i> Thêm
                            </CButton>
                            <CButton color="secondary" class="mt-3 ml-2" @click="timeRange = []">
                              <i class="fa fa-eraser"></i> Xóa tất cả
                            </CButton>
                          </CCol>
                        </CRow>
                      </CCardBody>
                    </CCard>
                    <div class="valid-error" v-show="!(validatorRangeTimes ? validatorRangeTimes.isValid : true)">
                      {{ validatorRangeTimes ? validatorRangeTimes.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <!-- <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 2">
                  <div class="form-group">
                    <label for="datepicker">Thời gian kết thúc phát
                      <span class="required">*</span></label>
                    <br/>
                    <DatePicker
                      id="endTimeUrgencyPicker"
                      mode="time"
                      v-model="endTimeUrgency"
                      :masks="{ input: 'HH:MM', data: 'HH:MM' }"
                      is24hr>
                    </DatePicker>
                  </div>
                </CCol> -->
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSchedule.data.model == 0 && modeSelect.data.model == 1">
                  <div class="form-group">
                    <label for="selectedDateWeek">Ngày phát <span class="required">*</span></label>
                    <multiselect
                      id="selectedDateWeek"
                      v-model="selectedDateWeek.data.model"
                      placeholder="Ngày phát"
                      label="value"
                      track-by="key"
                      :options="selectedDateWeek.data.items"
                      selectLabel="Chọn"
                      deselectLabel="Bỏ chọn"
                      selectedLabel="Đã chọn"
                      :close-on-select="false"
                      :multiple="true"
                      :class="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true) ? 'input-error' : ''"
                    >
                      <span slot="noResult">Không có dữ liệu tương ứng!</span>
                      <span slot="noOptions">Danh sách rỗng!</span>
                    </multiselect>
                    <div class="valid-error"
                         v-show="!(selectedDateWeek.data.validator ? selectedDateWeek.data.validator.isValid : true)">
                      {{ selectedDateWeek.data.validator ? selectedDateWeek.data.validator.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" xl="6" v-if="modeSelect.data.model == 1 && modeSchedule.data.model == 1">
                  <div class="form-group"
                       :class="!(validatorDates ? validatorDates.isValid : true) ? 'input-error' : ''">
                    <label for="datepicker">Ngày phát <span class="required">*</span></label>
                    <CCard class="mb-1">
                      <CCardBody style="padding-top: 5px !important">
                        <DatePicker
                          id="datepicker"
                          mode="date"
                          v-model="selectedDate.date"
                          :masks="{ input: 'DD/MM/YYYY', data: 'DD/MM/YYYY' }"
                          :min-date="minDate"
                          :max-date="maxDate"
                        >
                          <template
                            #default="{
                              inputValue,
                              togglePopover,
                              hidePopover,
                            }"
                          >
                            <div class="flex flex-wrap">
                              <CButton
                                v-for="(each, i) in dates"
                                :key="each.date.getTime()"
                                color="light"
                                class="mr-3 mt-3 btn-date"
                                style="position: relative"
                                @click.stop=" dateSelected($event, each, togglePopover)"
                                ref="btnDate"
                              >
                                {{ $helper.formatDateDDMMYYYY(each.date) }}
                                <div class="btn-remove">
                                  <svg
                                    class="w-1 h-1"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    @click.stop="removeDate(each, hidePopover)"
                                  >
                                    <path d="M6 18L18 6M6 6l12 12"></path>
                                  </svg>
                                </div>
                              </CButton>
                            </div>
                          </template>
                        </DatePicker>
                        <CButton color="primary" class="mt-3" @click="addDate">
                          <i class="fa fa-plus"></i> Thêm ngày
                        </CButton>
                        <CButton color="secondary" class="mt-3 ml-2" @click="dates = []">
                          <i class="fa fa-eraser"></i> Xóa tất cả
                        </CButton>
                      </CCardBody>
                    </CCard>
                    <div class="valid-error" v-show="!(validatorDates ? validatorDates.isValid : true)">
                      {{ validatorDates ? validatorDates.errorMessage : "" }}
                    </div>
                  </div>
                </CCol>
              </CRow>
              <br/>
              <CRow>
                <CCol xs="12" md="12" lg="12" xl="12">
                  <CButton color="primary" @click="submitData()"
                  ><i class="fa fa-save"></i> Lưu
                  </CButton
                  >
                  <CButton color="secondary" class="ml-2" @click="resetData()"><i class="fa fa-eraser"></i> Làm mới</CButton>
                  <CButton color="secondary" class="ml-2" @click="$router.go(-1)"><i class="fa fa-reply"></i> Hủy bỏ</CButton>
                </CCol>
              </CRow>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal title="Lịch phát đã tồn tại" :show.sync="exist.isShowModelExist" :closeOnBackdrop="false">
      <CRow class="pb-2">
        <CCol xs="12" md="12" lg="12" xl="12">
          Đã tồn tại lịch phát ngày <span style="font-weight:bold">{{ exist.playDate }}</span>
          khung giờ <span style="font-weight:bold">{{ exist.startTime + ' - ' + exist.endTime }}</span>
          với các thiết bị:
          <span v-for="i of exist.devices">
            <br/>
            {{ '- ' + i }}
          </span>
        </CCol>
      </CRow>
      <template v-slot:footer>
        <button type="button" class="btn btn-secondary" @click="exist.isShowModelExist = false"><i
          class="fa fa-times"></i> Hủy bỏ
        </button>
        <button type="button" class="btn btn-primary" @click="$router.push(`${exist.id}/managed-shedule-detail.html`)">
          <i class="fa fa-eye"></i> Xem lịch đã tồn tại
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import {DatePicker} from "v-calendar";
import Multiselect from "vue-multiselect";
import BaseLoading from "@/views/base/BaseFormLoading";

export default {
  name: "ScheduleAdd",
  components: {
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    Multiselect,
    BaseLoading,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let today = new Date();
    return {
      isSelectedAllDevices: false,
      loading: {value: false},
      minDate: today,
      maxDate: today,
      dates: [],
      selectedDate: {},
      exist: {
        id: "",
        msg: "",
        playDate: "",
        startTime: "",
        endTime: "",
        devices: [],
        isShowModelExist: false
      },
      endTimeUrgency: this.$helper.plusDate(10, 'm')._d,
      actionData: {
        model: {
          listFileSelectedId: [],
        },
      },
      dateRange: {
        start: new Date(),
        end: new Date(),
      },
      timeRange: [],
      deviceInput: {
        options: [],
        data: {
          name: "devices",
          model: "",
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.deviceInput.data.model;
              if (value === "" || that.deviceInput.data.model.length == 0) {
                this.isValid = false;
                this.errorMessage = "Thiết bị không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      slideShowInput: {
        options: {
          filter: true,
          label: "Trình diễn <span class='required'>*</span>",
          keyField: "value",
          valueField: "text",
          selectAllText: "Chọn Trình diễn",
        },
        data: {
          name: "slideShowId",
          model: "",
          source: {
            url: "/slide_show/find-slide-show-active",
            ignoreDefaultData: true,
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.slideShowInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Trình diễn không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      modeSelect: {
        options: {
          label: "Chế độ phát",
          filter: false,
        },
        data: {
          name: "mode",
          items: [
            {key: "0", value: "Khung giờ cố định"},
            {key: "1", value: "Theo lịch phát đã thiết lập"},
            // {key: "2", value: "Khẩn cấp phát ngay"},
          ],
          model: "0",
        },
      },
      modeSchedule: {
        options: {
          label: "Kiểu lịch",
          filter: false,
        },
        data: {
          name: "modeSchedule",
          items: [
            {key: "0", value: "Theo ngày trong tuần"},
            {key: "1", value: "Theo ngày trong tháng"},
          ],
          model: "0",
        },
      },
      selectedDateWeek: {
        options: {
          label: "Ngày phát",
        },
        data: {
          name: "selectedDateWeek",
          model: "",
          items: [
            {key: "2", value: "Thứ 2"},
            {key: "3", value: "Thứ 3"},
            {key: "4", value: "Thứ 4"},
            {key: "5", value: "Thứ 5"},
            {key: "6", value: "Thứ 6"},
            {key: "7", value: "Thứ 7"},
            {key: "1", value: "Chủ nhật"},
          ],
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedDateWeek.data.model;
              if (
                (value === "" || value.length == 0) &&
                that.modeSelect.data.model == 1 &&
                that.modeSchedule.data.model == 0
              ) {
                this.isValid = false;
                this.errorMessage = "Ngày phát phát không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            },
          },
        },
      },
      validatorRangeTimes: {
        isValid: true,
        errorMessage: "",
        valid: function () {
          let value = that.timeRange;
          if ((value === "" || value.length == 0) && that.modeSelect.data.model != 2) {
            this.isValid = false;
            this.errorMessage = "Thời điểm phát không được để trống";
          } else {
            this.isValid = true;
          }
          return this.isValid;
        },
      },
      validatorDates: {
        isValid: true,
        errorMessage: "",
        valid: function () {
          let value = that.dates;
          if (
            (value === "" || value.length == 0) &&
            that.modeSelect.data.model == 1 &&
            that.modeSchedule.data.model == 1
          ) {
            this.isValid = false;
            this.errorMessage = "Ngày phát phát không được để trống";
          } else {
            this.isValid = true;
          }
          return this.isValid;
        },
      },
    };
  },
  computed: {},
  methods: {
    changeSelectedAllDevice(value) {
      if (value) {
        this.deviceInput.data.model = this.deviceInput.options;
      } else {
        this.deviceInput.data.model = '';
      }
    },
    submitData: function () {
      let that = this;
      let isValid = true;
      isValid &= that.slideShowInput.data.validator.valid();
      isValid &= that.validatorRangeTimes.valid();
      isValid &= that.selectedDateWeek.data.validator.valid();
      isValid &= that.validatorDates.valid();
      isValid &= that.deviceInput.data.validator.valid();
      if (!isValid) {
        return;
      } else {
        let res = {};
        let dates = [];
        for (let i = 0; i < that.dates.length; i++) {
          dates.push(that.$helper.formatDateDDMMYYYY(that.dates[i].date.getTime()));
        }
        let startTimes = [];
        let endTimes = [];
        let times = [];
        for (let i = 0; i < that.timeRange.length; i++) {
          var startTime = that.$helper.formatHHMM(that.timeRange[i].start.getTime());
          var endTime = that.$helper.formatHHMM(that.timeRange[i].end.getTime());
          startTimes.push(startTime);
          endTimes.push(endTime);
          times.push(startTime + " - " + endTime);
        }

        if (that.modeSelect.data.model == 2) {
          endTimes.push(that.$helper.formatHHMM(that.endTimeUrgency.getTime()));
        }

        let devices = [];
        for (let i = 0; i < that.deviceInput.data.model.length; i++) {
          devices.push(that.deviceInput.data.model[i].value);
        }

        res.dates = dates;
        res.startTimes = startTimes;
        res.endTimes = endTimes;
        res.fromDate = that.$helper.formatDateDDMMYYYY(that.minDate.getTime());
        res.toDate = that.$helper.formatDateDDMMYYYY(that.maxDate.getTime());

        res.mode = that.modeSelect.data.model;
        res.modeSchedule = that.modeSchedule.data.model;
        res.slideShowId = that.slideShowInput.data.model;
        res.times = times;
        res.devices = devices;
        if (that.selectedDateWeek.data.model.length > 0) {
          res.selectedDateWeek = [];
          for (let i = 0; i < that.selectedDateWeek.data.model.length; i++) {
            res.selectedDateWeek.push(that.selectedDateWeek.data.model[i].key);
          }
        }
        that.$helper.loadDataSource({
          loading: that.loading,
          url: "/schedule/add",
          dataSubmit: function () {
            return res;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              if (response.data.data.id) {
                // that.showErrorMsg({message: that.$helper.getStringError(response.data.data.msg)});
                // that.$helper.setupErrorModel(response.data.data.msg, that.$data);
                that.exist.id = response.data.data.id;
                that.exist.msg = response.data.data.msg;
                that.exist.startTime = response.data.data.startTime;
                that.exist.endTime = response.data.data.endTime;
                that.exist.playDate = response.data.data.playDate;
                that.exist.devices = response.data.data.devices;
                that.exist.isShowModelExist = true;
              } else {
                that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
                that.$helper.setupErrorModel(response.data.data, that.$data);
              }
            } else {
              that.showSuccessMsg({
                message: "Thêm mới lịch phát thành công",
              });
              that.$router.push("/schedule-management/managed-shedule.html");
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          },
        });
      }
    },
    changeTimeRange(event, index) {
      this.timeRange.splice(index, 1, event);
    },
    addTimeRange() {
      this.timeRange.push({start: new Date(), end: new Date()})
    },
    removeTimeRange(index) {
      this.timeRange.splice(index, 1);
    },
    addDate() {
      let that = this;
      // this.dates.push({date: new Date()});
      var date = new Date();
      date.setDate(this.dateRange.start.getDate());
      this.dates.push({date: date});
      this.$nextTick(() => {
        setTimeout(() => {
          const btn = that.$refs.btnDate[that.$refs.btnDate.length - 1];
          btn.click();
        }, 50);
      });
    },
    removeDate(date, hide) {
      this.dates = this.dates.filter((d) => d !== date);
      hide();
    },
    dateSelected(e, date, toggle) {
      this.selectedDate = date;
      toggle({ref: e.target});
    },
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    resetData() {
      this.modeSelect.data.model = "0";
      this.modeSchedule.data.model = "0";
      this.minDate = new Date();
      this.maxDate = new Date();
      this.endTimeUrgency = {};
      this.timeRange = [];
      (this.dateRange = {
        start: this.minDate,
        end: this.maxDate,
      }),
        this.resetTime();
      this.deviceInput.data.model = "";
      this.slideShowInput.data.model = "";
      this.isSelectedAllDevices = false;
    },
    resetTime() {
      this.startTimes = [];
      this.endTimes = [];
      this.selectedDateWeek.data.model = [];
      this.dates = [];
    },
    loadDataDevices() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/devices/find-all",
        dataSubmit: function () {
          return {
            orgId: ''
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.deviceInput.options = response.data.data;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        },
      });
    },
  },
  created: function () {
  },
  mounted() {
    this.loadDataDevices()
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.minDate = newValue.start;
        this.maxDate = newValue.end;
      }
    },
    "modeSelect.data.model": function (newValue) {
      if (newValue) {
        this.resetTime();
      }
    },
    "modeSchedule.data.model": function (newValue) {
      if (newValue) {
        this.resetTime();
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.btn-date:hover .btn-remove {
  display: inline-flex !important;
}

.btn-remove {
  display: none !important;
  position: absolute;
  width: 15px;
  height: 15px;
  background: red;
  color: white;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  top: -5px;
  right: -5px;
}

.custom-checkbox
.custom-control-input:indeterminate
~ .custom-control-label::before {
  border-color: unset;
  background-color: unset;
}

.form-group.input-error .card {
  border-color: #ff7070 !important;
}

.btn-time-ranger:hover ~ .btn-remove-time {
  display: inline-block !important;
}

.btn-remove-time {
  width: 18px;
  cursor: pointer;
  font-weight: bold;
  position: absolute;
  top: 10px;
  right: 0;
  padding: 2px;
  border-radius: 50%;
  background: red;
  color: white;
}
</style>
<style lang="scss">

#addSchedule {
  .multiselect {
    min-height: 36px !important;
    margin-top: -2px;

    &.input-error .multiselect__tags {
      border-color: #ff7070;
    }

    .valid-error {
      animation: fade-down ease-out .2s;
      animation-fill-mode: forwards;
    }

    .multiselect__tags {
      padding-top: 0px !important;
      min-height: 36px !important;
    }


    .multiselect__tag {
      margin-top: 5px !important;
      margin-bottom: 0 !important;
    }
  }

  .multiselect__input {
    line-height: unset !important;
    font-size: 14px !important;
    padding-top: 5px !important;
  }


  .multiselect__placeholder {
    padding-top: 7px !important;
    margin: 0 !important;
  }
}
</style>
